import classNames from 'classnames';
import React from 'react';
import VehicleSubscription from '../../subscription/components/VehicleSubscription';

const TugaIframe: React.FC<{}> = () => {
    return (
        <React.Fragment>
            <div className={classNames(['grid-x', 'grid-margin-x', 'my-bmw-servicos-value-service-prime'])}>
                <VehicleSubscription vehcode={-2} isLanding={true} isTugaIframe={true} />
            </div>
        </React.Fragment>
    );
};

export default TugaIframe;
